import { AttachmentImageFull } from "~/common/components/image/AttachmentImageFull";
import { AttachmentImageLabel } from "~/common/components/image/AttachmentImageLabel";
import { ImageAttachmentData } from "~/models/card";
import { CardItemLabel } from "./CardItem";

export function CardItemImage({
  image,
  imagePosition,
  label,
}: {
  image?: ImageAttachmentData;
  imagePosition: string;
  label?: CardItemLabel;
}) {
  if (label) {
    return (
      <AttachmentImageLabel
        image={image}
        imagePosition={imagePosition}
        label={label}
      />
    );
  }

  if (image && image.src) {
    return <AttachmentImageFull image={image} imagePosition={imagePosition} />;
  }

  return null;
}
